import { CorrectionFeedback, PronounceRubyRequest } from '@entities/lesson'
import { useTranslation } from '@shared/config/i18n'
import { clsx } from 'clsx'
import React, { Suspense } from 'react'

import { Box, HStack, Typography, VStack } from '@podo-app/design-system-temp'

type Props = {
  feedback: CorrectionFeedback
}

export const JapaneseCorrectionFeedback = ({ feedback }: Props) => {
  const t = useTranslation()
  const studentAnswer = feedback.phrase.student_sentence.map((studentSentencePart: string, index: number) => (
    <span
      key={`student-sentence-${index}`}
      className={clsx(feedback.phrase.student_highlight.includes(index) && 'text-red-normal')}
    >
      {studentSentencePart}
    </span>
  ))
  const masterAnswer = feedback.phrase.ai_sentence.map((masterSentencePart: string, index: number) => (
    <span
      key={`student-sentence-${index}`}
      className={clsx(feedback.phrase.ai_highlight.includes(index) && 'text-blue-normal')}
    >
      {masterSentencePart}
    </span>
  ))

  return (
    <React.Fragment>
      <VStack className="gap-2 min-w-0 max-w-full ">
        <HStack>
          <Box className="border rounded-[14px] px-3 py-[3px] bg-white border-gray-200">
            <Typography size="body1" className="font-medium">
              {t('lesson.feedbackLabels.myExpression')}
            </Typography>
          </Box>
        </HStack>
        <VStack className="gap-0.5 w-full overflow-hidden">
          <Typography size="h1" className="font-medium font-noto-jp" lang="ja">
            <Suspense fallback={studentAnswer}>
              <PronounceRubyRequest
                text={feedback.phrase.student_sentence.join('')}
                highlight={feedback.phrase.student_highlight}
                highlightClassName="text-red-normal"
              />
            </Suspense>
          </Typography>
        </VStack>
      </VStack>

      <Box className="border divide-dashed" />

      <VStack className="gap-2 min-w-0 max-w-full ">
        <HStack>
          <Box className="border rounded-[14px] px-3 py-[3px] bg-white border-gray-200">
            <Typography size="body1" className="font-medium">
              {t('lesson.feedbackLabels.correctedExpression')}
            </Typography>
          </Box>
        </HStack>
        <VStack className="gap-0.5 overflow-hidden">
          <Typography size="h1" className="font-medium font-noto-jp max-w-full w-full" lang="ja">
            <Suspense fallback={masterAnswer}>
              <PronounceRubyRequest
                text={feedback.phrase.ai_sentence.join('')}
                highlight={feedback.phrase.ai_highlight}
                highlightClassName="text-blue-normal"
              />
            </Suspense>
          </Typography>
        </VStack>
      </VStack>

      <Box className="border divide-dashed" />

      <VStack className="gap-2 min-w-0 max-w-full overflow-hidden">
        <HStack>
          <Box className="border rounded-[14px] px-3 py-[3px] bg-white border-gray-200">
            <Typography size="body1" className="font-medium">
              {t('lesson.feedbackLabels.feedback')}
            </Typography>
          </Box>
        </HStack>
        <VStack className="gap-0.5 min-w-0 max-w-full overflow-hidden">
          <Typography size="body1" className="text-gray-500">
            {feedback.phrase.ai_explanation}
          </Typography>
        </VStack>
      </VStack>
    </React.Fragment>
  )
}
